export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdEdtDmsprint';
export const NAME = 'NastaveniTisku';
